module.exports = __webpack_public_path__ + "img/how-to-generate-random-pictures-with-free-api.681a539b.jpg";